import { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function SignaturePad({ open, onClose, onSave, label }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      const c = ref.current;
      if (!c) return;
      c.width = c.offsetWidth * 2;
      c.height = c.offsetHeight * 2;
      const ctx = c.getContext("2d");
      ctx.scale(2, 2);
      ctx.lineWidth = 2.2;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.strokeStyle = "#0f172a";
      setEmpty(true);
    }, 50);
    return () => clearTimeout(t);
  }, [open]);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { drawing.current = true; ref.current.setPointerCapture(e.pointerId); const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); setEmpty(false); };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); };
  const save = () => { setBusy(true); ref.current.toBlob(async (b) => { try { await onSave(b); onClose(); } finally { setBusy(false); } }, "image/png"); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="signature-pad-dialog">
        <DialogHeader>
          <DialogTitle>Draw signature — {label}</DialogTitle>
          <DialogDescription>Sign with your mouse, finger or pen in the box below.</DialogDescription>
        </DialogHeader>
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
          className="h-48 w-full touch-none rounded-lg border-2 border-dashed border-slate-300 bg-white" data-testid="signature-pad-canvas" />
        <div className="flex justify-between gap-2">
          <Button type="button" variant="outline" onClick={clear} data-testid="signature-pad-clear">Clear</Button>
          <Button type="button" onClick={save} disabled={empty || busy} data-testid="signature-pad-save">{busy ? "Saving..." : "Save signature"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
